// extracted by mini-css-extract-plugin
module.exports = {"confirmationStepHeader":"styles_confirmationStepHeader__l5hZ5","checkoutStepHeader":"styles_checkoutStepHeader__2vuQ8","bookingConfirmedIcon":"styles_bookingConfirmedIcon__D8_p7"};